// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.LCD[data-v-17ad8a26] {\r\n    display: flex;\r\n    align-items: center;\n}\n.LCD>div[data-v-17ad8a26] {\r\n    font-family: \"alarm clock\";\r\n    font-size: x-large;\n}\r\n", ""]);
// Exports
module.exports = exports;
